module.exports = __webpack_public_path__ + "static/media/24UHCHR4.959b46d8.jpg";